import styled from 'styled-components';
import { services } from '../utils/constants';
import { useState, useEffect, memo } from 'react'


const Services = () => {
    const [offSetY, setOffSetY] = useState(0)

    const handleParallax = () => {
        setOffSetY(window.pageYOffset)
    }

    useEffect(() => {
        window.addEventListener('scroll', handleParallax)
        return () => {
            window.removeEventListener('scroll',handleParallax)
        }
    }, [])

    return (
        <Contents id="services">
            <h1
            style = {
                { transform: `translateY(-${offSetY * 0.15}px)`}
            }
            >
                Services
            </h1>
            <h2>When Passion meets Creativity!</h2>
            <section>
            {services.map((service) => {
                return <Service key={service.id} {...service}/>
            })}
            </section>
        </Contents>
    )
}


const Service = memo(({ icon, title, content, id}) => {
    const [offSetY, setOffSetY] = useState(0)
    const [speed, setSpeed] = useState(1)

    const handleParallax = () => {
        setOffSetY(window.pageYOffset)
        window.innerWidth >= 700 ? setSpeed(3) : setSpeed(1)
    }

    useEffect(() => {
        window.addEventListener('scroll', handleParallax)
        return () => {
            window.removeEventListener('scroll',handleParallax)
        }
    }, [])

    return (
        <div
        className="service"
        style = {
            { transform: `translateY(-${offSetY * id * speed}px)`}
        }
        >
            <div className="service-icon">
                <i className={icon}></i>
            </div>
            <h3>{title}</h3>
            <p>{content}</p>
        </div>
    )
})

const Contents = styled.div`
    padding-bottom: 4rem;
    background: #ffffff;
    h1 {
        font-weight: 700;
        text-align: center;
        margin-top: 3rem;
        font-size: 2rem;
    }
    h2 {
        text-align: center
    }
    
    .service {
        display: flex;
        flex-flow: column wrap;
        align-items: center;
        margin-top: 2rem;
    }
    .service > * {
        width: 80%;
        text-align: center;
    }
    .service > p,.service > h3 {
        margin-top: 1rem;
    }
    .service-icon {
        width: 150px;
        height: 150px;
        border: 2px solid #000;
        border-radius: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 3rem;
    }
    i {
        cursor: alias
    }
    @media screen and (min-width: 700px) {
        section {
            display: flex;
            flex-flow: row nowrap;
            padding-top: 8rem;
        }
    }
    @media screen and (max-width: 440px) {
        h2 {
            font-size: 1.3rem;
        }
    }
    `;

export default memo(Services);